// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetUserByRealtyIdRequest, TGetUserByRealtyIdModel, IMappers, TGetUserByRealtyIdResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetUserByRealtyIdResponse } from '../../entities/user/GetUserByRealtyIdResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetUserByRealtyIdModel(parameters: IGetUserByRealtyIdRequest): TGetUserByRealtyIdModel {
  return {
    v: 1,
    apiType: 'private',
    method: 'GET',
    microserviceName: 'user-data-aggregation',
    pathApi: '/v1/get-user-by-realty-id/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetUserByRealtyIdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetUserByRealtyIdRequest;
}

export async function fetchGetUserByRealtyId<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetUserByRealtyIdOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetUserByRealtyIdResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetUserByRealtyIdModel(parameters),
    config,
  )) as FetchResponse<TGetUserByRealtyIdResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUserByRealtyIdResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetUserByRealtyIdResponse>;
}
